/**
 * Относительный формат прошедшей даты:
 *   < 1 мин            → "только что"
 *   < 1 ч              → "12 мин назад"
 *   сегодня, < 6 ч     → "3 ч назад"
 *   сегодня, ≥ 6 ч     → "сегодня 15:07"
 *   вчера              → "вчера 17:50"
 *   старше             → "21.06 15:07"
 */
export function formatRelative(
  iso: string | Date | null | undefined,
): string {
  if (!iso) return "—";
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return "—";
  const now = new Date();
  const diffSec = Math.floor((now.getTime() - d.getTime()) / 1000);

  if (diffSec < 60) return "только что";
  if (diffSec < 3600) {
    const m = Math.floor(diffSec / 60);
    return `${m} мин назад`;
  }

  const startOfToday = new Date(now);
  startOfToday.setHours(0, 0, 0, 0);
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);

  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");

  if (d >= startOfToday) {
    if (diffSec < 6 * 3600) {
      const h = Math.floor(diffSec / 3600);
      return `${h} ч назад`;
    }
    return `сегодня ${hh}:${mm}`;
  }
  if (d >= startOfYesterday) return `вчера ${hh}:${mm}`;
  const dd = String(d.getDate()).padStart(2, "0");
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}.${mo} ${hh}:${mm}`;
}
